import type { SingleAssetValueOverview } from '@einwert/valuation-api-client'
import { Popover, Stack } from '@mui/material'
import { assembleAssetTitle, BuildingIcon, Image, joinDefinedStrings, tokens } from 'ComponentLibrary'

import { useRef, useState } from 'react'
import { AssetLocation } from 'ClientPortal/src/pages/MarketData/types'
import { Typography } from 'ComponentLibrary/src/piazza/text'

type MarketDataSidebarOptionProps = {
    asset: SingleAssetValueOverview
    setSelectedLocation: (location: AssetLocation) => void
}

export const MarketDataSidebarOption = ({ asset, setSelectedLocation }: MarketDataSidebarOptionProps) => {
    const anchorEl = useRef<HTMLDivElement | null>(null)
    const [isPopOverOpen, setIsPopOverOpen] = useState(false)

    return (
        <Stack
            ref={anchorEl}
            key={asset.uuid}
            direction="column"
            padding={tokens.SizingSpacing100}
            sx={{
                borderRadius: tokens.SizingCornerS,
                '&:hover': { backgroundColor: tokens.ColorSurfaceAccentGreyDefault, cursor: 'pointer' },
            }}
            onClick={() => setSelectedLocation(asset)}
            onMouseEnter={() => setIsPopOverOpen(true)}
            onMouseLeave={() => setIsPopOverOpen(false)}
        >
            {asset.title_image && (
                <Popover
                    id={asset.uuid}
                    open={isPopOverOpen}
                    anchorEl={anchorEl.current}
                    sx={{ pointerEvents: 'none', '& .MuiPaper-root': { lineHeight: '0' } }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 50,
                        horizontal: 50,
                    }}
                    disableRestoreFocus
                >
                    <Image
                        sx={{ borderRadius: tokens.SizingCornerS }}
                        height="131"
                        width="177"
                        objectFit="cover"
                        src={asset.title_image}
                        alt=""
                    />
                </Popover>
            )}
            <Stack direction="row" gap={tokens.SizingSpacing100} width="100%" color={tokens.ColorTextBoldest}>
                <BuildingIcon style={{ height: tokens.SizingIconM, minWidth: tokens.SizingIconM }} />
                <Stack direction="column" gap={tokens.SizingSpacing075}>
                    <Typography variant="headline3">
                        {assembleAssetTitle({ ...asset.address, customer_asset_reference: asset.customer_asset_reference })}
                    </Typography>
                    <Stack direction="column">
                        <Typography variant="textM" color={tokens.ColorTextBold}>
                            {joinDefinedStrings([asset.address.street, asset.address.house_number])}
                        </Typography>
                        <Typography variant="textM" color={tokens.ColorTextBold}>
                            {joinDefinedStrings([asset.address.zip, asset.address.city])}
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    )
}
